<template>
    <div class="content">
        <div class="card my-1">
            <div
                class="collapse show"
                aria-labelledby="headingTwo"
                data-parent="#accordionResult"
            >
                <!-- 流程执行记录 -->
                <div class="card-body">
                    <div class="bs-component"></div>
                    <div class="col-lg-12">
                        <h5>
                            <span class="text-primary">流程执行记录</span>
                        </h5>
                    </div>
                </div>
            </div>
            <b-table
                striped
                hover
                responsive
                caption-top
                :items="items"
                :fields="fields"
                stacked="md"
            >
                <template v-slot:cell(show_details)="row">
                    <b-button size="sm" @click="row.toggleDetails" class="mr-2">
                        {{ row.detailsShowing ? '隐藏' : '显示' }} 详情
                    </b-button>
                </template>
                <template v-slot:row-details="row">
                    <div>
                        <b-card-group deck>
                            <b-card v-for="(comment,index) of row.item.commentList"
                                    :key="'comment'+index"
                                    header="评论"
                                    border-variant="Primary"
                            >
                                <b-card-text>{{ comment.fullMessage }}</b-card-text>
                            </b-card>
                            <b-card header="附件"
                                    border-variant="Primary"
                            >
                                <!--                                todo：缓存一下，应该只第一次加载才向后端发请求-->
                                <em-attachment getItemsBySelf :attachmentIds="row.item.attachmentIds"
                                ></em-attachment>
                            </b-card>
                        </b-card-group>
                    </div>
                </template>
            </b-table>
        </div>
    </div>
</template>

<script>

import {mapActions, mapState} from 'vuex'
import EmAttachment from "@/components/em/EmAttachment";

export default {
    name: "WorkflowProcessExecution",
    components: {EmAttachment},
    props: {
        processDefinitionKey: String,
        businessKey: Number,
        approvedLabels: {
            type: Object,
            default() {
                return {
                    1: '通过',
                    0: '拒绝'
                }
            }
        }
    },
    data: function () {
        return {
            processExecutionEntityName: "workflowProcessExecution",
            items: [],
            fields: [
                {key: "name", label: "任务名称"},
                {key: "owner", label: "发起人"},
                {key: "assignee", label: "办理人"},
                {key: "startTime", label: "开始时间"},
                {key: "duration", label: "经历时间"},
                {key: "approved", label: "审批结果"},
                {key: "show_details", label: "详细"}
            ]
        }
    },
    computed: {
        ...mapState({
            processExecutionDoGet: state => state.workflow.processExecutionDoGet,
        })
    },
    watch: {
        processExecutionDoGet(val, old) {
            if (val && !old) {
                this.initData();
                this.$store.commit('workflow/setProcessExecutionDoGet', false);
            }
        }
    },
    methods: {
        ...mapActions(
            {
                apiPost: "api/post"
            }
        ),
        initData() {
            this.apiPost({
                url: process.env.VUE_APP_EM_WORKFLOW_URL + "/getProcessExecution",
                data: {
                    processDefinitionKey: this.processDefinitionKey,
                    businessKey: this.businessKey
                }
            }).then(response => {
                console.log("this is EmWorkflowProcessExecution")
                console.log(response.data)
                if (response.data.taskHistoricList.length > 0) {
                    let taskHistoricList = response.data.taskHistoricList
                    taskHistoricList.forEach(taskHistoric => {
                        taskHistoric.approved = this.approvedLabels[taskHistoric.approved]
                    })
                    this.items = taskHistoricList
                    this.$emit('gotItems', response.data.taskHistoricList);
                }
            })
        }
    },
    mounted() {

    }
}
</script>

<style scoped>

</style>
